import { Box, Button, Menu, MenuItem } from "@mui/material";
import { FILTER_OPTION_MAP, SETUP_FILTER_OPTIONS } from "../../Enums/Enum";
import { useEffect, useState } from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    IconButton,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import EditActionDialog from "./EditActionDialog";

import EditIcon from "../../Images/edit.png"
import DeleteIcon from "../../Images/delete.png"
import CustomPagination from "../../Components/CustomPagination";
import { deleteJobTitle, getJobMasterList } from "../../api";
import { Loader } from "../../HelperFunctions/HelperFunctions";
import { enqueueSnackbar, SnackbarProvider } from "notistack";
import { useAlerts } from "../../Hooks";
import PayrollsPopup from "../../Components/PayrollPopup";

const JobTitleMaster = () => {

    const [menuAnchor, setMenuAnchor] = useState(null);
    const { popup: alertPopup, showDeleteConfirm, hidePopup } = useAlerts();
    const [filters, setFilters] = useState({
        jobTitle: { label: "Contains", value: "contains" },
        search: { label: "Contains", value: "contains" },
    });
    const [activeField, setActiveField] = useState(null);
    const [search, setSearch] = useState("");
    const [jobTitle, setJobTitle] = useState("");

    const [debouncedFilters, setDebouncedFilters] = useState({
        search: "",
        jobTitle: "",
    });
    const [page, setPage] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [jobTitleData, setJobTitleData] = useState([]);

    const [openDialog, setOpenDialog] = useState(false);
    const [dialogMode, setDialogMode] = useState("add");
    const [selectedRow, setSelectedRow] = useState(null);
    const [loading, setLoading] = useState(true);

    const compactTextFieldSx = {
        "& .MuiInputBase-root": {
            height: 30,
            fontSize: "12px",
        },
        "& .MuiInputBase-input": {
            padding: "6px 8px",
            fontSize: "12px",
            fontWeight: 500
        },
    };
    const headerStyleSX = {
        position: "sticky",
        top: 0,
        zIndex: 3,
        background: "#f1f1f1",
        color: "#4482ec",
        fontWeight: "bold",
    };

    const stickyHeaderSx = {
        position: "sticky",
        top: 42,
        zIndex: 2,
        background: "white",
    };
    const cellStyle = {
        fontSize: 12,
        fontWeight: 500,
        color: "#626262",
    };

    const StyledCell = ({ children }) => (
        <TableCell sx={cellStyle}>{children}</TableCell>
    );

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedFilters({
                search,
                jobTitle,
            });
        }, 500);

        return () => clearTimeout(timer);
    }, [search, jobTitle, page]);

    useEffect(() => {

        getTitlesList();
    }, [debouncedFilters, filters]);

    const getTitlesList = async () => {

        try {
            setLoading(true)

            const masterListPayload = {
                JobTitle: {
                    SearchTerm: debouncedFilters.jobTitle,
                    FilterOption: FILTER_OPTION_MAP[filters.jobTitle.value]
                },
                IsActive: {
                    SearchTerm: debouncedFilters.search,
                    FilterOption: FILTER_OPTION_MAP[filters.search.value]
                },
                PageNum: page
            };
            const list = await getJobMasterList(masterListPayload);
            // if (list?.StatusCode !== 200) {
            //     setLoading(false);
            //     enqueueSnackbar(`${list?.Status}`, { variant: "warning" })
            //     return;
            // };

            const totalRecords = list?.JobTitleResp?.[0]?.TotalRecords || 0;
            const pageSize = list?.JobTitleResp?.[0]?.MaxRows;
            setTotalPages(Math.ceil(totalRecords / pageSize));
            setJobTitleData(list?.JobTitleResp || []);
        } catch (error) {
            console.error(error)
        } finally {
            setLoading(false);

        }


    };

    const handleAddClick = () => {
        setDialogMode("add");
        setSelectedRow(null);
        setOpenDialog(true);
    };

    const handleEditClick = (row) => {
        setDialogMode("edit");
        setSelectedRow(row);
        setOpenDialog(true);
    };

    const handleFilterClick = (event, field) => {
        setMenuAnchor(event.currentTarget);
        setActiveField(field);
    };

    const handleDelete = async (row) => {
        // const confirmDelete = window.confirm("Are you sure you want to delete this item?");

        // if (!confirmDelete) return;
        try {
            setLoading(true);
            const deleteItem = await deleteJobTitle(row.ID);
            if (deleteItem?.StatusCode === 200) {
                enqueueSnackbar(deleteItem?.Status, { variant: "success" });
                getTitlesList();
            } else {
                enqueueSnackbar(deleteItem?.Status, { variant: "error" });
            }
        } catch (error) {
            console.error(error);
            enqueueSnackbar(error?.response?.data?.Status || "Error while Delete", { variant: "error" });
        } finally {
            setLoading(false);
        }
    };




    const headers = [
        { key: "jobTitle", label: "Job Title" },
        { key: "status", label: "Status", sx: { width: 300 } },
        {
            key: "action",
            label: (
                <Button
                    variant="outlined"
                    size="small"
                    onClick={handleAddClick}
                    // sx={{
                    //     backgroundColor: "white",
                    //     color: "#4482ec",
                    //     px: 1,
                    //     "&:hover": {
                    //         color: "white",
                    //         backgroundColor: "#3d5c7b",
                    //     },
                    // }}
                    sx={{ border: "1px solid #b5dcf2" }}
                >
                    Add New
                </Button>
            ),
        },
    ];


    return (
        <SnackbarProvider
            maxSnack={1}
            anchorOrigin={{
                vertical: "top",
                horizontal: "right",
            }}
            autoHideDuration={2000}
        >
            <Box height={"100%"} width={"100%"} border={"1px solid lightgrey"}>
                <TableContainer sx={{ height: "calc(100% - 32px)" }}>
                    <Table size="small">

                        <TableHead>
                            <TableRow>
                                {headers.map((item) => (
                                    <TableCell
                                        key={item.key}
                                        sx={{ ...headerStyleSX, borderRight: "1px solid white", ...(item.sx || {}) }}
                                    >
                                        {item.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                            <TableRow>
                                <TableCell
                                    sx={stickyHeaderSx}
                                >
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                        <TextField
                                            size="small"
                                            fullWidth
                                            sx={compactTextFieldSx}
                                            placeholder="Search..."
                                            onChange={(e) => setJobTitle(e.target.value)}
                                        />

                                        <IconButton size="small" onClick={(e) => handleFilterClick(e, "jobTitle")}>
                                            <FilterListIcon fontSize="small" />
                                        </IconButton>
                                    </Box>
                                </TableCell>

                                <TableCell
                                    sx={stickyHeaderSx}
                                >
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                        <TextField
                                            size="small"
                                            fullWidth
                                            sx={compactTextFieldSx}
                                            placeholder="Search..."
                                            onChange={(e) => setSearch(e.target.value)}
                                        />

                                        <IconButton size="small" onClick={(e) => handleFilterClick(e, "search")}>
                                            <FilterListIcon fontSize="small" />
                                        </IconButton>
                                    </Box>
                                </TableCell>

                                <TableCell
                                    sx={stickyHeaderSx}
                                />
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {loading ? (
                                <TableRow>
                                    <TableCell colSpan={3} align="center" sx={{ py: 6, position: "relative" }}>
                                        <Loader loading={loading} />
                                    </TableCell>
                                </TableRow>
                            ) : jobTitleData.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={3} align="center" sx={{ py: 3, color: "gray" }}>
                                        No Data Found
                                    </TableCell>
                                </TableRow>
                            ) : (
                                jobTitleData.map((row) => (
                                    <TableRow key={row.ID} hover>
                                        <StyledCell>
                                            <span title={row.JobTitle}>{row.JobTitle}</span>
                                        </StyledCell>
                                        <StyledCell>
                                            <span >{row.IsActive === 0 ? "Inactive" : "Active"}</span>
                                        </StyledCell>
                                        <TableCell>
                                            <IconButton size="small" onClick={() => handleEditClick(row)}>
                                                <img src={EditIcon} alt="" width={18} height={18} />
                                            </IconButton>
                                            <IconButton size="small"
                                                // onClick={() => handleDelete(row)}
                                                onClick={() =>
                                                    showDeleteConfirm(
                                                        "Are you sure you want to delete this item?",
                                                        () => handleDelete(row)
                                                    )
                                                }
                                            >
                                                <img src={DeleteIcon} alt="" width={18} height={18} />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))
                            )}
                        </TableBody>

                    </Table>
                </TableContainer>
                <CustomPagination
                    count={totalPages}
                    page={page}
                    onChange={(e, newPage) => setPage(newPage - 1)}
                />
            </Box >

            <Menu
                anchorEl={menuAnchor}
                open={Boolean(menuAnchor)}
                onClose={() => setMenuAnchor(null)}
                PaperProps={{
                    sx: { maxHeight: 300, width: "150px" }
                }}
            >
                {SETUP_FILTER_OPTIONS.map((option) => (
                    <MenuItem
                        key={option.value}
                        onClick={() => {
                            setFilters((prev) => ({
                                ...prev,
                                [activeField]: option,
                            }));
                            setMenuAnchor(null);
                        }}
                        selected={filters[activeField]?.value === option.value}
                        sx={{
                            fontSize: "0.75rem",
                            "&.Mui-selected": {
                                backgroundColor: "#275D97",
                                color: "white",
                                "&:hover": { backgroundColor: "#275D97" }
                            }
                        }}
                    >
                        {option.label}
                    </MenuItem>
                ))}
            </Menu>


            {openDialog &&
                <EditActionDialog
                    open={openDialog}
                    onClose={() => setOpenDialog(false)}
                    mode={dialogMode}
                    data={selectedRow}
                    onSave={getTitlesList}
                />
            }
            {<Loader loading={loading} />}
            <PayrollsPopup
                open={alertPopup.open}
                popupType={alertPopup.type}
                message={alertPopup.message}
                onConfirm={alertPopup.onConfirm}
                onCancel={hidePopup}
            />

        </SnackbarProvider>

    );


}


export default JobTitleMaster;